import { useEffect, useRef, useState } from 'react'
import type { recipeLink } from '../../../../utils/recipeUtils'

import './RecipeLink.scss'

interface RecipeLinkProps {
  index: number
  link: recipeLink
  setLink: (index: number, newLink: recipeLink) => void
}

function RecipeLink({ index, link, setLink }: RecipeLinkProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  const [url, setUrl] = useState<string>(link.url)
  const [editing, setEditing] = useState<boolean>(!link.url)

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus()
    }
  }, [editing])

  function handleBlur() {
    if (url) {
      setEditing(false)
    }
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter') {
      setEditing(false)
    }
  }

  function checkLinkModified(newUrl: string) {
    return newUrl !== link.url
  }

  function handleUrlChange(newUrl: string) {
    setUrl(newUrl)
    if (checkLinkModified(newUrl)) {
      const newLink: recipeLink = {
        ...link,
        url: newUrl,
        modified: true,
      }
      setLink(index, newLink)
    }
  }
  function handleDelete() {
    const newLink: recipeLink = { ...link, deleted: true }
    setLink(index, newLink)
  }
  return (
    <div className="recipe-list-item" key={index}>
      {editing ? (
        <input
          ref={inputRef}
          type="text"
          className="recipe-link-url"
          defaultValue={url}
          onChange={e => handleUrlChange(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          placeholder="Enter URL..."
        />
      ) : (
        <a
          className="recipe-link-url"
          href={
            url.startsWith('http://') || url.startsWith('https://')
              ? url
              : `https://${url}`
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          {url}
        </a>
      )}

      <button
        className="recipe-link-edit-button"
        onClick={() => setEditing(true)}
      >
        ✎
      </button>
      <button className="recipe-link-delete-button" onClick={handleDelete}>
        ×
      </button>
    </div>
  )
}

export default RecipeLink
